// Footer.js
import React from 'react';
import icon1 from '../assets/icons/patrocinadores/american.svg';
import tsm from '../assets/images/logos/360.svg';
import stl from '../assets/images/logos/skip_line.svg';
import icon3 from '../assets/icons/patrocinadores/FAIRMONT.svg';
import icon4 from '../assets/icons/patrocinadores/VISA.svg';
import icon5 from '../assets/icons/patrocinadores/WHISTLER.svg';
import whats from '../assets/icons/small_icons/WHATSAPP.png';
import RowColLayout from './RowColLayout';

const Footer = () => {
  return (
    <>
      <style>
        {`
          .footer-icon {
            max-height: 5vh;
            width: auto;
            height: auto;
            max-width: 100%;
            display: block;
            object-fit: contain;
          }
        `}
      </style>

      
    <div className="row d-flex m-0 w-100 m-0 p-0">
      <div className='col-12 w-100 m-0 p-0'>
        <a
          href="https://wa.me/525656859418"  // <-- Replace with your real number
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Contact via WhatsApp"
          style={{ textDecoration: 'none' }}
        >
          <div className="row p-0 m-0 w-100">
            <div
              className="col d-flex justify-content-center align-items-center m-0 p-0"
              style={{ backgroundColor: "#6acb5f", cursor: "pointer" }}
            >
              <div className="d-flex align-items-center my-2">
                <p className="text-white mb-0 me-2">Ayuda WhatsApp</p>
                <img src={whats} alt="WhatsApp" style={{ width: "20px" }} />
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>

      <footer
        className="d-flex justify-content-center align-items-center"
        style={{
          backgroundColor: '#01153a',
          color: '#ffffff',
          textAlign: 'center',
          padding: '0',
          width: '100%',
          height: '7vh',
          position: 'relative',
          bottom: 0,
        }}
      >


<div className="row d-flex px-2 m-0 w-100">
  {/* Spacer on the left, only on md+ */}
  <div className="d-none d-md-block col"></div>
  <div className="d-none d-md-block col"></div>

  {/* First column: content right on md+ */}
  <div className="col d-flex justify-content-center justify-content-md-end align-items-center m-1 p-1">
    <p className='m-0 p-0'>Powered by</p>
  </div>

  {/* Middle column: always centered */}
  <div className="col d-flex justify-content-center align-items-center m-1 p-1">
    <img src={tsm} alt="360 logo" className="footer-icon p-2" />
  </div>

  {/* Last column: content left on md+ */}
  <div className="col d-flex justify-content-center justify-content-md-start align-items-center m-1 p-1">
    <img src={stl} alt="Skip the line logo" className="footer-icon p-2" />
  </div>

  {/* Spacer on the right, only on md+ */}
  <div className="d-none d-md-block col"></div>
  <div className="d-none d-md-block col"></div>
  
</div>
      </footer>
    </>
  );
};

export default Footer;
